import { ErrorHandler, Injectable, NgZone } from '@angular/core';
import { NavigationCancel, NavigationError } from '@angular/router';
import { SnackbarService } from '../services/snackbar.service';
import { LoggerService } from './logger.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(
    private readonly logger: LoggerService,
    private readonly snackbar: SnackbarService,
    private readonly zone: NgZone,
  ) {}

  handleError(error: unknown): void {
    if (this.isNoisyNavigationEvent(error)) {
      return;
    }

    this.logger.error('GlobalErrorHandler', error);
  }

  private isNoisyNavigationEvent(error: unknown): boolean {
    return error instanceof NavigationCancel || error instanceof NavigationError;
  }
}
